import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideCore } from '@core/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { authInitializer } from '@core/utils/auth.initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withComponentInputBinding(),
    ),
    provideCore(),
    provideCharts(withDefaultRegisterables()),
    provideAppInitializer(authInitializer),
  ],
};
